// extracted by mini-css-extract-plugin
export default {"button":"RestaurantsButton_button__OWLUV","disable":"RestaurantsButton_disable__ZCbt9"};